<template>
  <v-dialog
    v-model="dialog"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="1200px"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" fab dark absolute bottom right>
        <v-icon>edit</v-icon>
      </v-btn>
      <v-hover v-slot:default="{ hover }">
        <v-card :elevation="hover ? 0 : 0" v-on="on">
          <v-card-text class="ma-0 pa-0" v-html="text"></v-card-text>
        </v-card>
      </v-hover>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text style="color:black" class="ma-0 pa-0">
        <v-container>
          <v-row >
            <v-col  class="mx-4" xs="12">
              <vue-editor
                placeholder="Remember to include:
* About you
* Link to your pages and social
* How to contact you"
                :value="initalText"
                v-on:input="editedText = $event"
                :editorToolbar="customToolbar"
              ></vue-editor>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Hide</v-btn>
        <v-btn color="blue darken-1" text @click="save">Publish</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template> 

<script>
import { VueEditor } from "vue2-editor";

export default {
  props: ["title", "text", "syncText"],
  components: {
    VueEditor
  },
  data: function() {
    return {
      dialog: false,
      editedText: "",
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"]
      ]
    };
  },
  methods: {
    show() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    save() {
      this.dialog = false;
      this.syncText(this.editedText);
    }
  },
  computed: {
    initalText() {
      return this.text;
    }
  }
};
</script>